import { render, staticRenderFns } from "./CompanyTabUsers.vue?vue&type=template&id=36d46202&scoped=true&"
import script from "./CompanyTabUsers.vue?vue&type=script&lang=ts&"
export * from "./CompanyTabUsers.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d46202",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VDivider})
